/** A work order status: the client-named status in the colour of its group (design svc.css `.g-*`). */

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import type { WorkOrderGroup } from '../types/workOrderTypes';

import { useStatuses } from '@/features/service-setup';
import { groupTagProps, localName } from '@/features/service-setup';

export function useStatusName(): (statusId: string | null | undefined) => string {
  const { i18n } = useTranslation();
  const statuses = useStatuses();
  return (statusId) => {
    const s = statuses.data?.find((x) => x.id === statusId);
    return s === undefined ? '—' : localName(s, i18n.language);
  };
}

export function StatusTag({
  group,
  statusId,
  onClick,
  ariaLabel,
}: {
  /** The order's group; a feed row may leave it out — the status's own group is used then. */
  group?: WorkOrderGroup;
  statusId: string;
  onClick?: () => void;
  ariaLabel?: string;
}): React.JSX.Element {
  const name = useStatusName();
  const statuses = useStatuses();
  const tag = groupTagProps(group ?? statuses.data?.find((s) => s.id === statusId)?.group ?? 'new');
  if (onClick === undefined) return <Tag {...tag}>{name(statusId)}</Tag>;
  return (
    <Tag {...tag} style={{ ...tag.style, cursor: 'pointer' }}>
      <button
        type="button"
        onClick={onClick}
        aria-haspopup="menu"
        aria-label={ariaLabel}
        style={{ all: 'unset', cursor: 'pointer' }}
      >
        {name(statusId)} ▾
      </button>
    </Tag>
  );
}
